import axios from 'axios'
import {furnitureDataType, signerDataType, witnessDataType} from './agreementDataType'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST
const API_TOKEN = localStorage.getItem('api_token') || ''

export const UPLOADED_DOC_SIGNING = `${LOCAL_URL}/sign/uploadedDocSigning`
export const DOCUMENT_TEMPLATE = `${LOCAL_URL}/sign/documentTemplates`
export const TEMPLATE_SIGNING = `${LOCAL_URL}/sign/templateSigning`

const headers = {
  Authorization: API_TOKEN,
}

// function to upload doc signing
export async function submitDocSigning(
  property_uuid: string,
  signers: signerDataType[],
  witness: witnessDataType[],
  sign_on_page: string,
  is_estamp: boolean,
  estamp_amount: number | string,
  estamp_quatity: number | string,
  estamp_state: number | string,
  file_data: string
) {
  return await axios.post(UPLOADED_DOC_SIGNING, {
    property_uuid,
    signers,
    witness,
    sign_on_page,
    is_estamp,
    estamp_amount,
    estamp_quatity,
    estamp_state,
    file_data,
  })
}

// function to get document template
export async function getDocumentTemplate() {
  return await axios.get(DOCUMENT_TEMPLATE, {headers})
}

// function for the template signing
export async function templateSigning(
  document_signing_template_uuid: string,
  lessor: signerDataType,
  lessee: signerDataType,
  sign_on_page: string,
  is_estamp: boolean,
  estamp_amount: number | string,
  estamp_quatity: number,
  estamp_state: number | string,
  property_uuid: string,
  lessor_courtesy_titles: string,
  lessor_full_name: string,
  lessor_age: number,
  lessor_address_1: string,
  lessor_address_2: string,
  lessor_address_city: string,
  lessor_address_state: string,
  lessor_address_pincode: string,
  lessor_pan: string,
  lessee_courtesy_titles: string,
  lessee_full_name: string,
  lessee_age: number,
  lessee_address_1: string,
  lessee_address_2: string,
  lessee_address_city: string,
  lessee_address_state: string,
  lessee_address_pincode: string,
  lessee_pan: string,
  lessee_mobiles: string,
  lessee_email_id: string,
  lessee_aadhar: string,
  property_address_1: string,
  property_address_2: string,
  property_address_city: string,
  property_address_state: string,
  property_address_pincode: string,
  property_rent_day: number,
  property_rent_monthly_amount: number,
  property_rent_monthly_amount_words: string,
  property_advance_amount: number,
  property_advance_amount_words: string,
  account_holder_courtesy_titles: string,
  account_holder_name: string,
  account_holder_pan: string,
  account_number: string,
  account_bank_name: string,
  account_bank_branch_name: string,
  account_bank_ifsc: string,
  rent_agreement_start_date: string,
  rent_agreement_end_date: string,
  property_short_description: string,
  agreement_generated_date: string,
  agreement_generated_city: string,
  agreement_jurisdiction_city: string,
  witness1: witnessDataType | string = "", //optional
  witness2: witnessDataType | string = "", //optional
  witness1_address_1: string  | string = "", //optional
  witness1_address_2: string  | string = "", //optional
  witness1_address_city: string  | string = "", //optional
  witness1_address_state: string  | string = "", //optional
  witness1_address_pincode: string  | string = "", //optional
  witness2_address_1: string  | string = "", //optional
  witness2_address_2: string  | string = "", //optional
  witness2_address_city: string  | string = "", //optional
  witness2_address_state: string  | string = "", //optional
  witness2_address_pincode: string  | string = "", //optional
  furnished_room_details: furnitureDataType[]  | string = "" //optional
) {
  return await axios.post(TEMPLATE_SIGNING, {
    document_signing_template_uuid,
    lessor,
    lessee,
    sign_on_page,
    is_estamp,
    estamp_amount,
    estamp_quatity,
    estamp_state,
    property_uuid,
    lessor_courtesy_titles,
    lessor_full_name,
    lessor_age,
    lessor_address_1,
    lessor_address_2,
    lessor_address_city,
    lessor_address_state,
    lessor_address_pincode,
    lessor_pan,
    lessee_courtesy_titles,
    lessee_full_name,
    lessee_age,
    lessee_address_1,
    lessee_address_2,
    lessee_address_city,
    lessee_address_state,
    lessee_address_pincode,
    lessee_pan,
    lessee_mobiles,
    lessee_email_id,
    lessee_aadhar,
    property_address_1,
    property_address_2,
    property_address_city,
    property_address_state,
    property_address_pincode,
    property_rent_day,
    property_rent_monthly_amount,
    property_rent_monthly_amount_words,
    property_advance_amount,
    property_advance_amount_words,
    account_holder_courtesy_titles,
    account_holder_name,
    account_holder_pan,
    account_number,
    account_bank_name,
    account_bank_branch_name,
    account_bank_ifsc,
    rent_agreement_start_date,
    rent_agreement_end_date,
    property_short_description,
    agreement_generated_date,
    agreement_generated_city,
    agreement_jurisdiction_city,
    witness1,
    witness2,
    witness1_address_1 ,
    witness1_address_2 ,
    witness1_address_city ,
    witness1_address_state,
    witness1_address_pincode ,
    witness2_address_1 ,
    witness2_address_2 ,
    witness2_address_city ,
    witness2_address_state ,
    witness2_address_pincode ,
    furnished_room_details ,
  })
}
